module.exports = __webpack_public_path__ + "static/media/gym_online.83c2ee72.jpg";